import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, changedRecord, filter }) =>
    present(
      repository
        .getTimeSheet(resource, changedRecord, filter)
        .then((timeSheet) => ({ resource, changedRecord, timeSheet, filter }))
        .catch(() => Promise.reject({ resource, changedRecord, filter })),
    );
}

export type { Interactor };

export { createInteractor };
